export const getGlobals = () => {
    if (typeof window === 'undefined') {
        return global.___storeGlobalVars || {};
    }
    return window.___storeGlobalVars || {};
};

export const setGlobals = (data) => {
    if (typeof window === 'undefined') {
        global.___storeGlobalVars = data;
    } else {
        window.___storeGlobalVars = data;
    }
};
